<script>
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const PRODUCT_PROMOTION_CLICK = analyticsUtilities.events.PRODUCT_PROMOTION_CLICK;

	module.exports = {
		components: {
			'lightning-icon': require('components/svg/lightning-icon.vue').default,
			'apple-icon': require('components/svg/apple-icon.vue').default,
			'ell-icon': require('components/svg/ell-icon.vue').default,
			'book-icon': require('components/svg/book-icon.vue').default
		},
		props: {
			applyFilters: {
				default: function () {
					return;
				}
			},
			changeSearchView: {
				default: function () {
					return;
				}
			}
		},
		modelData: ['gcAddon'],
		methods: {
			filterByAAD(filters, loc) {
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
				this.applyFilters(...filters);
			},
			onBlurbTextClick(loc) {
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
			},
			goToScopeAndSequence() {
				const loc = 'aad-promo-ss';
				fireEvent(PRODUCT_PROMOTION_CLICK, { loc });
				this.changeSearchView('scope-and-sequence');
			}
		}
	};
</script>
<style lang="scss">
	.promotion-panel.aad {
		.aad-video {
			position: relative;
			margin: 1rem 2rem;

			iframe.vimeo-player {
				height: auto;
				width: 100%;
			}
		}

		.promotion-content {
			max-width: 32rem;
		}

		.outbound-routine {
			display: inline-block;
		}
	}
</style>
<template>
	<div class="promotion-panel product-promotion-panel aad">
		<div class="promotion-title">
			<h2>Article-A-Day</h2>
			<a
				href="javascript:void(0)"
				@click="filterByAAD([{ id: 'AAD' }], 'AAD_BROWSE')"
				>See All
				<i
					class="fa-solid fa-arrow-right-long"
					aria-hidden="true"></i
			></a>
		</div>
		<div class="promotion-blurb">
			Transform students’ comprehension in just 10 minutes a day by building background knowledge, vocabulary, and reading stamina.
			<a
				href="/teacher-guide/article-a-day-routine.html"
				:target="gcAddon ? '_blank' : '_self'"
				@click="onBlurbTextClick('aad-promo-tg')"
				>Article-A-Day</a
			>
			provides weekly text sets of engaging nonfiction passages. Plan an entire year with our
			<component
				:is="gcAddon ? 'span' : 'a'"
				href="javascript:void(0)"
				@click="!gcAddon && goToScopeAndSequence">
				K-8 Scope & Sequences!
			</component>
		</div>
		<div class="article-features">
			<div class="feature-row">
				<button
					class="article-feature button -small -outline"
					@click="filterByAAD([{ id: 'SUPPORT_TEXTS' }, { id: 'AAD' }], 'AAD_SUPPORT')">
					<apple-icon></apple-icon>
					Boost
				</button>
				<button
					class="article-feature button -small -outline"
					@click="filterByAAD([{ id: 'CHALLENGE_TEXTS' }, { id: 'AAD' }], 'AAD_CHALLENGE')">
					<lightning-icon></lightning-icon>
					Challenge
				</button>
				<button
					class="article-feature button -small -outline"
					@click="filterByAAD([{ id: 'vocabulary' }, { id: 'AAD' }], 'AAD_VOCABULARY')">
					<book-icon></book-icon>
					Vocab Activities
				</button>
				<button
					class="article-feature button -small -outline"
					@click="filterByAAD([{ id: 'ELL' }, { id: 'AAD' }], 'AAD_ELL')">
					<ell-icon></ell-icon>
					ELL
				</button>
			</div>
		</div>
	</div>
</template>
